<p>inventory-stock works!</p>
